import React from "react";

import * as typography from "@client/shared/typography";

import {calculateMealMetrics, getRoundedCalculations} from "@client/calculations";
import {Card} from "@client/components/Card";
import {DaySummary} from "@client/components/DaySummary";
import {EntryCard} from "@client/components/EntryCard";
import {Flush} from "@client/components/Flush";
import {PieChart} from "@client/components/PieChart";
import {ManagerLayout} from "@client/site/ManagerLayout";
import * as forms from "@client/site/forms";
import {reverse, server} from "@reactivated";

import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.MealPlanDetail) => {
    const day = props.day;
    const useKilojoules = false;

    return (
        <ManagerLayout
            title={props.meal_plan.name}
            narrow
            currentClientManagerId={null}
        >
            <form
                noValidate
                method="POST"
                action=""
                className="flex flex-col space-y-[15px]"
            >
                <forms.CSRFToken />
                <ClientNavigation>
                    <typography.Header>{props.meal_plan.name}</typography.Header>
                    <typography.ButtonGroup>
                        <typography.Button href={`/journal/${props.meal_plan.id}/`}>
                            Modify
                        </typography.Button>
                        <typography.Button submit name="copy" value="">
                            Copy
                        </typography.Button>
                        <typography.Button
                            href={reverse("meal_plan_delete", {
                                meal_plan_id: props.meal_plan.id,
                            })}
                        >
                            Delete
                        </typography.Button>
                    </typography.ButtonGroup>
                </ClientNavigation>

                <Flush>
                    {day.meals.map((meal) => {
                        const calculations = getRoundedCalculations(
                            calculateMealMetrics(meal),
                            useKilojoules,
                        );

                        return (
                            <div key={meal.uuid}>
                                <Card
                                    item={meal}
                                    macros={calculations}
                                    hiddenMacros={false}
                                />
                                {meal.entries.map((entry) => (
                                    <EntryCard
                                        key={entry.uuid}
                                        indented
                                        entry={entry}
                                        hiddenMacros={false}
                                    />
                                ))}
                            </div>
                        );
                    })}
                    <DaySummary useKilojoules={false} day={day} target={day.target} />
                </Flush>
                <div style={{maxWidth: 400, height: 120, margin: "-10px auto"}}>
                    <PieChart {...props.status} />
                </div>
                <typography.Subheader>Settings</typography.Subheader>
                <forms.Fields form={props.form} />
                <typography.Button submit>Submit</typography.Button>
            </form>
        </ManagerLayout>
    );
};
